import React, { useEffect, useReducer, useState } from "react";
import {
  Grid,
  Alert,
  Box,
  Button,
  InputBase,
  alpha,
  styled,
} from "@mui/material";
import MainCard from "components/MainCard";
import { dispatch, useSelector } from "store";
import ScrollX from "components/ScrollX";
import { PAGINATION } from "utils/constants/pagination";
import { get } from "lodash";
import Wallets from "./Wallets";
import { fetchWallets, clearWallet } from "store/reducers/wallets";
import { WarningFilled } from "@ant-design/icons";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { exportData, formatAmount } from "utils/CommonMethods";
import toast from "utils/ToastNotistack";
import authApi from "interceptor/authInterceptor";
import { format } from "date-fns";
import Papa from "papaparse";
import SearchIcon from "@mui/icons-material/Search";
import T from "utils/constants/T";
import Loader from "components/Loader";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  border: "1px solid #d9d9d9",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1.5),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(3)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
  },
}));
const WalletsPage = () => {
  const { selectedCompany } = useSelector(
    (state: any) => state.dashboardSearch
  );
  const { systemCode, currencySymbol } = useSelector((state: any) => state.companyTabData);
  let cs = currencySymbol ? currencySymbol : T.DOLLAR;
  console.log(systemCode)
  const companyId = get(selectedCompany, "_id", "");
  const result = useSelector((state) => state.wallets);
  const { wallets, page, totalRecords, totalPages } = result;
  const { INITIAL_PAGE, ROWS_PER_PAGE, EXPORT_PAGE_SIZE } = PAGINATION;
  const [dataWindow, setDataWindow] = useState("CURRENT")

  const [localState, setLocalState] = useReducer(
    (prevState: any, newState: any) => ({ ...prevState, ...newState }),
    {
      pageNumber: INITIAL_PAGE,
      rowsPerPage: ROWS_PER_PAGE,
      employeeName: "",
      isLoading: false,
      payPeriodType: "current"
    }
  );

  const { rowsPerPage, employeeName, payPeriodType, isLoading } = localState;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const debounceTimerRef = React.useRef<NodeJS.Timeout>();
  const handlePageChange = (newPage: number) => {
    if (isLoading) return;
    // Clear previous debounce
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    // Debounce fetch by 300ms
    debounceTimerRef.current = setTimeout(() => {
      setLocalState({ isLoading: true, pageNumber: newPage });
      dispatch(clearWallet());
      dispatch(fetchWallets(newPage, rowsPerPage, companyId, employeeName, payPeriodType)).finally(() => {
        setLocalState({ isLoading: false });
      });

      const tableContainer = document.getElementsByClassName("MuiTableContainer-root")[0];
      if (tableContainer) {
        tableContainer.scrollTop = 0;
      }
    }, 300);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (isLoading) return;
    const newRowsPerPage = parseInt(event.target.value, 10);
    setLocalState({ isLoading: true, pageNumber: INITIAL_PAGE, rowsPerPage: newRowsPerPage });
    dispatch(clearWallet());
    dispatch(fetchWallets(INITIAL_PAGE, newRowsPerPage, companyId, employeeName, payPeriodType)).finally(() => {
      setLocalState({ isLoading: false });
    });
  };


  const exportWallets: any = async (
    page: number,
    pageSize: number,
    companyId: string,
    payPeriodType: string,
  ) => {
    // fetch wallets
    const response = await authApi.get(
      `/v2/api/users/wallets?page=${page}&page_size=${pageSize}&company_id=${companyId}&payperiod_type=${payPeriodType}`
    );
    const { data: employees, totalPages, page: currentPage } = response.data;

    // check for page size, if current page is equal or greater than totalPages, then return
    if (currentPage + 1 >= totalPages) return employees;

    // recursiverly fetch all wallets and return
    const nextPage = await exportWallets(page + 1, pageSize, companyId, payPeriodType);
    return [...employees, ...nextPage];
  };

  const formattedExportData = (wallets: any) => {
    const formattedData: any = [];

    wallets.forEach((wallet: any) => {
      const startDate = get(wallet, "start_date", "");
      const endDate = get(wallet, "end_date", "");
      const startDateFormatted = new Date(startDate);
      const endDateFormatted = new Date(endDate);
      const startDateText = format(startDateFormatted, "dd MMM yyyy");
      const endDateText = format(endDateFormatted, "dd MMM yyyy");
      const accuredAmount = formatAmount(
        get(wallet, "pay_calculates.accured_amount", "")
      );
      const withdrawalsTotal = formatAmount(
        get(wallet, "pay_calculates.withdrawals_total", "")
      );

      const salaryBalance =
        get(wallet, "pay_calculates.accured_amount", "") +
        get(wallet, "pay_calculates.withdrawals_total", "");

      formattedData.push({
        "First Name": get(wallet, "staff_infor.first_name", ""),
        "Last Name": get(wallet, "staff_infor.last_name", ""),
        "Full Name": get(wallet, "staff_infor.fullname", ""),
        Email: get(wallet, "staff_infor.email", ""),
        "Payroll Id": get(wallet, "staff_infor.system_employee_id", ""),
        "Pay Period": `${startDateText} To ${endDateText}`,
        "Balance Available": `${cs}` + formatAmount(
          get(wallet, "pay_calculates.amount_available", "")
        ),
        "Salary (Cycle)": `${cs}${salaryBalance}`,
        "CashD Limit": `${cs}` + formatAmount(
          get(wallet, "pay_calculates.limit_amount", "")
        ),
        "Current Fee": `${cs}` + formatAmount(
          get(wallet, "pay_calculates.current_fee", "")
        ),
        "CashD Withdrawals": `${cs}` + withdrawalsTotal,
        "Salary Balance (cycle)": `${cs}` + accuredAmount,
      });
    });

    return formattedData;
  };

  const handleCSVExport = async () => {
    try {
      setLocalState({ isLoading: true });
      const employees = await exportWallets(
        INITIAL_PAGE,
        EXPORT_PAGE_SIZE,
        companyId,
        payPeriodType
      );
      const finalExportData = formattedExportData(employees);
      const csvData = Papa.unparse(finalExportData);
      exportData(csvData, "data.csv", "text/csv;charset=utf-8;");
      setLocalState({ isLoading: false });
    } catch (error) {
      toast(get(error, "message", ""), { variant: "error" });
    }
  };

  useEffect(() => {
    const fetchWalletData = async () => {
      dispatch(clearWallet());
      setLocalState({
        pageNumber: INITIAL_PAGE,
        employeeName: "",
        isLoading: true
      });
      await dispatch(
        fetchWallets(INITIAL_PAGE, rowsPerPage, companyId, "", payPeriodType)
      );
      setLocalState({ isLoading: false });
    };

    if (companyId) fetchWalletData();
  }, [companyId, payPeriodType]);

  const searchDebounceRef = React.useRef<NodeJS.Timeout>();
  const handleEmployeeNameSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setLocalState({ employeeName: value });

    // Clear previous debounce
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    // Always debounce search (including empty/clear)
    searchDebounceRef.current = setTimeout(() => {
      dispatch(clearWallet());
      setLocalState({
        pageNumber: INITIAL_PAGE,
        isLoading: true
      });
      dispatch(fetchWallets(INITIAL_PAGE, rowsPerPage, companyId, value, payPeriodType)).finally(() => {
        setLocalState({ isLoading: false });
      });
    }, 500);
  };

  return (
    <>
      {isLoading && <Loader />}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {!companyId && (
            <Alert color="warning" icon={<WarningFilled />}>
              Please select a company first
            </Alert>
          )}

          {companyId && (
            <MainCard>
              <Box sx={{ display: "flex" }}>
                <Grid container>
                  <Search>
                    <SearchIconWrapper>
                      <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                      placeholder={T.EMPLOYEE}
                      value={employeeName}
                      inputProps={{ "aria-label": "search" }}
                      onChange={handleEmployeeNameSearch}
                    />
                  </Search>
                </Grid>
                <Grid container justifyContent="flex-end" gap={1}>
                  {companyId && systemCode === T.ASTUTE.toUpperCase() && (
                    <>
                      <Button
                        variant={dataWindow === "CURRENT" ? "contained" : "text"}
                        disabled={isLoading}
                        onClick={(e) => {
                          if (payPeriodType === "current") return;
                          dispatch(clearWallet());
                          setLocalState({ payPeriodType: "current", pageNumber: INITIAL_PAGE, isLoading: true });
                          setDataWindow("CURRENT");
                        }}
                      >
                        Current
                      </Button>
                      <Button
                        variant={dataWindow === "LAST" ? "contained" : "text"}
                        disabled={isLoading}
                        onClick={(e) => {
                          if (payPeriodType === "last") return;
                          dispatch(clearWallet());
                          setLocalState({ payPeriodType: "last", pageNumber: INITIAL_PAGE, isLoading: true });
                          setDataWindow("LAST");
                        }}
                      >
                        Last
                      </Button>
                    </>)}
                  <Box>
                    <Button
                      startIcon={<FileDownloadOutlinedIcon />}
                      variant="contained"
                      onClick={handleCSVExport}
                      disabled={!totalRecords ? true : false}
                    >
                      {" "}
                      Export
                    </Button>
                  </Box>
                </Grid>
              </Box>

              <ScrollX>
                <Wallets
                  wallets={wallets}
                  dataWindow={dataWindow}
                  page={page}
                  pageSize={rowsPerPage}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  isLoading={isLoading}
                  open={open}
                  anchorEl={anchorEl}
                  handleClick={handleClick}
                  handleClose={handleClose}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              </ScrollX>
            </MainCard>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default WalletsPage;
